import { COMMON_CHART_FONT_STYLES, getChartFontColor, getChartGridColor } from '../../../../utils/chart';

export const createOptions = ({ theme, config, data }) => {
  const fontColor = getChartFontColor(theme);
  const gridColor = getChartGridColor(theme);

  return {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: 'y',
    elements: {
      bar: {
        borderRadius: 5,
      },
    },
    interaction: {
      mode: 'index',
      axis: 'y',
    },
    plugins: {
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          color: fontColor,
          usePointStyle: true,
          boxWidth: 8,
          font: COMMON_CHART_FONT_STYLES,
          padding: 20,
        },
      },
      tooltip: {
        mode: 'index',
        axis: 'y',
        intersect: false,
        enabled: !config.tooltip,
        external: function (context) {
          config.tooltip && getTooltipsCustomConfig(context, { config: config.tooltip, data });
        },
      },
      ...(config.datalabels ? { datalabels: { ...config.datalabels } } : {}),
    },
    scales: {
      x: {
        offset: true,
        position: 'top',
        stacked: true,
        ticks: {
          color: fontColor,
          font: COMMON_CHART_FONT_STYLES,
        },
        grid: {
          display: true,
          drawTicks: false,
          color: gridColor,
        },
      },
      y: {
        offset: true,
        position: 'left',
        stacked: true,
        ticks: {
          display: false,
        },
        grid: {
          display: true,
          drawTicks: false,
          color: gridColor,
        },
      },
    },
  };
};

const getTooltipsCustomConfig = (context, { config: configTooltip, data }) => {
  const { chart, tooltip: tooltipModel } = context;

  // Tooltip Element
  let tooltipEl = document.getElementById('chartJsStackedHorizontalBars');

  // Create element on first render
  if (!tooltipEl) {
    tooltipEl = document.createElement('div');
    tooltipEl.id = 'chartJsStackedHorizontalBars';
    document.body.appendChild(tooltipEl);
  }

  // Hide if no tooltip
  if (tooltipModel.opacity === 0) {
    tooltipEl.style.opacity = 0;
    return;
  }

  // Set caret Position
  tooltipEl.classList.remove('above', 'below', 'no-transform');
  if (tooltipModel.yAlign) {
    tooltipEl.classList.add(tooltipModel.yAlign);
  } else {
    tooltipEl.classList.add('no-transform');
  }

  if (tooltipModel.body) {
    tooltipEl.innerHTML = configTooltip.createMarkup(tooltipModel, data);
  }

  // Get the canvas bounds
  const canvasBounds = chart.canvas.getBoundingClientRect();

  // Calculate tooltip position
  const positionX = canvasBounds.left + window.scrollX;
  const positionY = canvasBounds.top + window.scrollY + tooltipModel.caretY;

  // Display, position, and set styles for font
  tooltipEl.style.opacity = 1;
  tooltipEl.style.pointerEvents = 'none';
  tooltipEl.style.position = 'absolute';
  tooltipEl.style.transform = 'translate(0, -50%)';
  tooltipEl.style.transition = 'all .5s ease';
  tooltipEl.style.left = positionX + 'px';
  tooltipEl.style.top = positionY + 'px';
  tooltipEl.style.font = tooltipModel.options.bodyFont.string;
  tooltipEl.style.padding = tooltipModel.options.padding + 'px ' + tooltipModel.options.padding + 'px';
};
